import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ContextService } from '../context.service';
import { LayoutComponent } from '../layout/layout.component';

@Component({
    selector: 'mutara-non-degree',
    templateUrl: './non-degree.component.html',
    styleUrls: ['./non-degree.component.scss'],
    standalone: false
})
export class NonDegreeComponent extends LayoutComponent implements OnInit {

  constructor(
    http: HttpClient,
    actRoute: ActivatedRoute,
    location: Location,
    router: Router,
    contextService: ContextService
  ) {
    super(http, actRoute, router, location, contextService);

    contextService.setLayoutId(contextService.findLayout('Non-Degree Classes'));
  }

  isEmbed: boolean = false;

  ngOnInit() {
    super.ngOnInit();

    this.actRoute.queryParams.subscribe((params:any) => {
      this.isEmbed = (params.embedded == 'true');
      let defaultData = Object.keys(params).reduce((acc : any, key) => {
        if ( key == 'number') {
          acc['quick_search'] = params[key];
        } else {
        acc['mad_class-' + key] = params[key];
        }
        return acc;
      }, {});
      console.log('Defaults for application %O', defaultData);
      this.formModel['class-select'] = {
        search: defaultData,
//        additional_filters: {'mad_class-number': params.number},
        _filter: { ...params }
      };
      Object.keys(params).forEach( key => {
        this.formModel['class-select']['mad_class-' + key] = params[key];
      });
    });
  }

  getCartCount() {
    return this.contextService.getCartCount();
  }

}
